export const legalLinks = [
  { to: "/pricing", label: "Pricing" },
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms of Service" },
  { to: "/refund-policy", label: "Refund Policy" },
  { to: "/disclaimer", label: "Disclaimer" },
  { to: "/cookie-policy", label: "Cookie Policy" },
  { to: "/shipping-policy", label: "Shipping Policy" },
  { to: "/data-deletion", label: "Data Deletion" },
  { to: "/grievance", label: "Grievance" },
  { to: "/contact", label: "Contact" },
];
